class AppEventTarget extends EventTarget {}

const appEventTarget = new AppEventTarget();

export default appEventTarget;

export const appEventTypes = {
  TOKEN_CHANGE: "TOKEN_CHANGE",
  LOGOUT_REQUEST: "LOGOUT_REQUEST",
  BRIEF_TAB_CHANGE: "BRIEF_TAB_CHANGE",
  TOOLTIP_OPEN: "TOOLTIP_OPEN",
};
